import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import { connect } from 'react-redux'
import Modal from '../../../basic-component/Modal'
// import SendNotice from './SendNotice';
const $ = require('jquery');
require('jszip');
require('pdfmake');
$.DataTable = require('datatables.net-bs4');
// require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-keytable-bs4');
require('datatables.net-responsive-bs4');
class Diary extends Component {


    
    componentDidMount() {
        let noticeData=this.props.noticeData;
        this.$el = $(this.el);
        var table = this.$el.DataTable({
            // lengthChange: false,
            dom: 'lBfrtip',
            data: noticeData,
            columns: [
                { data: 'slno' },
                { data: 'notice' },
                { data: 'message' },
                { data: 'to' },
                { data: 'from' },
                { data: 'date' },               

            ],

            buttons: [
                // {
                //     extend: 'pdf',
                //     text: 'PDF',
                //     className: 'btn btn-success'
                // },
                {
                    extend: 'csv',
                    text: 'CSV',
                    title: "Students Records",
                    className: 'btn btn-success btn-sm'
                },
                {
                    extend: 'print',
                    text: 'Print',
                    title: "<h1 class='text-center'>Student Record</h1>",
                    className: 'btn btn-success btn-sm'
                }
            ]
        });
        table.buttons().container().appendTo(".export-buttons ");
        $('#myTable tbody').on('dblclick', 'tr', function () {
            var data = table.row(this).data();
            console.log(data);
            alert('You clicked on ' + data.name + '\'s row');
        });

    }

    render() {
        let noticeTable = (<div>
            {/* <h2 className="text-secondary" style={{ paddingLeft: "0.5rem", paddingTop: "1rem" }}>Student</h2> */}
            <div className="card card-design-2">
                <div className="card-header bg-primary text-white">
                    Notice Board List
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-4 col-sm-12">
                            {/* <div className="row">
                                <div className="mr-1 pd-1"> Select Class</div>
                                <select className="form-control"><option>Std 1</option></select>
                            </div> */}
                        </div>
                        <div className="col-lg-8 col-sm-12 text-right export-buttons">
                            <button className="btn btn-primary btn-sm" data-toggle="modal" data-target="#myModal"><i className="fa fa-plus"></i> Send Notice</button>&nbsp;
                            {/* <div className="export-buttons"></div> */}
                        </div>
                    </div>
                    <div className="row">
                    
                        
                        <div className=" table-responsive" style={{ padding: "10px" }}>
                            <table id="myTable" className="table table-hover table-bordered dt-responsive nowrap" width="100%" ref={el => this.el = el} >
                                <thead>
                                    <tr>
                                        <th>Sl No</th>
                                        <th>Notice</th>
                                        <th>Message</th>
                                        <th>To</th>
                                        <th>From</th>
                                        <th>Date</th>
                                        
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
        return (
            <div>
                 {/* <Modal header="Send Notice" modalWidth="modal-md" modalId="myModal" action="Send Notice"><SendNotice /></Modal> */}
                {/* <Modal header="Student Info" modalWidth="modal-xl" modalId="studentInfoModal" action="Update"><Student studentDetail={this.state.currentStudent} /></Modal> */}
                {noticeTable}
                {/* <div>
                    <Switch>
                        <Route path="/Classes/AddClasses" component={AddClasses} />
                        <Route path="/Classes" exact render={() => classes} />
                    </Switch>

                </div> */}
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        isUserLoggedIn: state.isAuthenticated,
        noticeData: state.noticeData
    };
}
const mapDispatchToProps = dispatch => {
    return {
        addStudentToStore: (newStudent) => dispatch({ type: 'AddStudent', studentData: newStudent }),
        deleteStudentToStore: (roll) => dispatch({ type: "DeleteStudent", roll: roll })
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Diary);
